var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HdNotifications',{staticClass:"deal-notifications",attrs:{"notifications":_vm.notifications},on:{"heightChange":_vm.onNotificationsHeightChange},scopedSlots:_vm._u([{key:"default",fn:function({ notification }){return [_c('NotificationItem',{attrs:{"notification":notification,"loading":_vm.loading}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }